const reviewsMixin = {
  computed: {
    customReview() {
      return (
        this.qrCode?.businessEntity.feedbackLabel &&
        this.qrCode?.businessEntity.feedbackUrl &&
        this.qrCode?.businessEntity.feedbackUrl.length
      );
    },
    tripAdviser() {
      return (
        this.transactionInfo?.tripadvisorEnabled &&
        this.transactionInfo?.tripadvisorUrl &&
        this.transactionInfo?.tripadvisorUrl.length
      );
    },
    googleReview() {
      return (
        this.transactionInfo?.googlereviewEnabled &&
        this.transactionInfo?.googlereviewUrl &&
        this.transactionInfo?.googlereviewUrl.length
      );
    },
    oneReviewButtonIsEnabled() {
      return this.customReview || this.tripAdviser || this.googleReview;
    },
  },
};

export default reviewsMixin;
